import { Badge, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';
import { Table, ToggleMenu } from '@hero/molecules';

const ProductDetailWrapper = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;

  ${DEVICE.mobile.max} {
    flex-direction: column;
  }
`;

const ProductDetailNotification = styled.div`
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  margin-top: 16px;
  padding-top: 16px;
`;
const ProductDetail = styled.div`
  display: flex;
  flex: 1.3;
  flex-direction: column;
`;

const ProductDetailImageArea = styled.div`
  flex: 1;
`;

const ProductDesc = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  overflow-y: auto;

  .show-more {
    margin-bottom: 8px;
  }

  .product-desc,
  .product-desc ul,
  .product-desc ul li {
    color: var(--color-neutral-800);
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
  }

  .product-desc ul,
  .product-desc ul li {
    list-style-type: disc;
    margin: 0 0 0 10px;
  }
`;
const ProductImageWrapper = styled.div`
  width: 100%;

  img {
    border: 1px solid var(--color-accent-secondary-weaker);
    border-radius: var(--size-border-radius-md);
    max-height: 100%;
    object-fit: contain;
  }
`;
const ProductPriceWrapper = styled.div`
  display: flex;
  margin-top: 8px;
`;

const EGiftCardInternationalText = styled(Typography)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: var(--size-gap-4);
`;

const AttrListWrapper = styled.div`
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 16px;
  padding-top: 16px;
`;

const OptionListItem = styled.li`
  list-style: disc;
  list-style-position: inside;
  margin-top: 4px;
`;

const OptionList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 4px;
  margin-top: 16px;
  overflow-y: scroll;
`;

const AttrWrapper = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 8px;
`;

const AttrBody = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const Option = styled(Typography)`
  display: flex;
  flex: 1;
  gap: 4px;
  line-height: 16px;
`;

const SKUPrice = styled(Typography)``;

const ConfigureAccordion = styled.div`
  width: 100%;

  ${ToggleMenu.S.ToggleChildrenWrapper} {
    padding: 0;
  }

  ${Table.S.Wrapper} {
    border: none;
    border-radius: 0;
  }
`;

const ImageWrapper = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  height: 60px;
  margin: 12px 0;
  width: 60px;
`;

const ProductStockWrapper = styled.div`
  ${Badge.S?.Badge} {
    background-color: var(--color-bg-body);
    color: var(--color-fg-default);
    cursor: default;
    font-size: 12px;
    font-weight: 600;
  }
`;

const ProductCardBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;
const ProductCardBrandInnerWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const ProductCardBrandImage = styled.div`
  align-items: center;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 6px;
  width: fit-content;
`;

const ProductCardBrandCode = styled.div`
  align-items: center;
  color: var(--color-neutral-400);
  display: flex;
  font-size: 14px;
  gap: 4px;
`;

const ProductCardBrandCodeSpan = styled.span`
  font-size: 12px;
  font-weight: bold;
`;

const VerticalBasketHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
`;

const VerticalBasketBody = styled.div`
  display: flex;
  margin-top: -16px;
  padding: 0 16px 16px 16px;
  position: relative;
  width: 100%;

  .swiper {
    height: 100%;
    width: 100%;
  }

  .swiper-wrapper {
    overflow: unset;
    padding-top: 6px;
  }
`;

const IconWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-circle); //
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
`;

const SwiperPrevNavigation = styled.div`
  align-items: center;
  background: linear-gradient(270deg, #ffffff 20.5%, rgba(255, 255, 255, 0) 191.49%);
  bottom: 0;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 100%;
  justify-content: center;
  left: 0;
  margin-top: 0;
  padding: 8px 4px;
  position: absolute;
  top: 0;
  width: 32px;
  z-index: 1;

  ${IconWrapper} {
    transform: rotate(-180deg);
  }

  &.swiper-button-disabled {
    display: none;
  }
`;

const SwiperNextNavigation = styled.div`
  align-items: center;
  background: linear-gradient(270deg, #ffffff 20.5%, rgba(255, 255, 255, 0) 191.49%);
  bottom: 0;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 100%;
  justify-content: center;
  margin-top: 0;
  padding: 8px 4px;
  position: absolute;
  right: -1px;
  top: 0;
  width: 32px;
  z-index: 1;

  &.swiper-button-disabled {
    display: none;
  }
`;

const VerticalBasketTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const VerticalBasket = styled.div`
  align-items: flex-start;
  background-color: var(--color-bg-body);
  bottom: 56px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  left: 0;
  margin-top: -24px;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

const ProductDetailShipmentType = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
  padding: 8px 0;
`;

const ProductDetailGeneralWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const SkuTableDescription = styled(Typography)`
  margin: 0 16px 16px 16px;
`;

const FeeBreakdownButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  width: 100%;
`;

export {
  AttrBody,
  AttrListWrapper,
  AttrWrapper,
  ConfigureAccordion,
  EGiftCardInternationalText,
  FeeBreakdownButtonWrapper,
  IconWrapper,
  ImageWrapper,
  Option,
  OptionList,
  OptionListItem,
  ProductCardBrand,
  ProductCardBrandCode,
  ProductCardBrandCodeSpan,
  ProductCardBrandImage,
  ProductCardBrandInnerWrapper,
  ProductDesc,
  ProductDetail,
  ProductDetailGeneralWrapper,
  ProductDetailImageArea,
  ProductDetailNotification,
  ProductDetailShipmentType,
  ProductDetailWrapper,
  ProductImageWrapper,
  ProductPriceWrapper,
  ProductStockWrapper,
  SKUPrice,
  SkuTableDescription,
  SwiperNextNavigation,
  SwiperPrevNavigation,
  VerticalBasket,
  VerticalBasketBody,
  VerticalBasketHeader,
  VerticalBasketTitle
};
